import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './Title.scss';
function Title(p) {
    return <View className="title-container">
      <Text className="title-style" numberOfLines={2}>{p.title}</Text>
    </View>;
}
export default memo(Title);
